import { FC } from "react";
import { RaffleCard, formatTimeLeft } from "entities/wheel-raffle";
import { getRafflePreview } from "../model/rafflePreview";
import type { CreateRaffleForm } from "../model/useCreateRaffle";

import styles from "./RafflePreviewPanel.module.css";

interface Props {
  form: CreateRaffleForm;
}

const getWinnersLabel = (winners: number): string => {
  if (winners === 1) return "The winner gets";
  return winners > 1 ? `Each of ${winners} winners gets` : "Each winner gets";
};

// Карточка такая же, как на табло: организатор сразу видит, что получат игроки.
export const RafflePreviewPanel: FC<Props> = ({ form }) => {
  const { values, realBalance } = form;
  const preview = getRafflePreview(values, realBalance);

  return (
    <div className={styles.panel}>
      <span className={styles.caption}>Preview</span>
      <RaffleCard
        title="New promo"
        timeLeft={formatTimeLeft(values.durationSec)}
        raffle={{
          id: 0,
          visibility: values.visibility,
          prize_pool_usdt: preview.pool,
          participants_count: 0,
          ends_at: "",
        }}
      />
      <div className={styles.perWinner}>
        <span className={styles.perWinnerLabel}>
          {getWinnersLabel(preview.winners)}
        </span>
        <span className={styles.perWinnerValue}>{preview.perWinner} USDT</span>
      </div>
      <div className={styles.balance}>
        <span>Balance after</span>
        <span className={preview.isOverBalance ? styles.negative : undefined}>
          {preview.balanceAfter} USDT
        </span>
      </div>
    </div>
  );
};
